import {Loader} from '@orbit-ui/components/loader';
import {useNavigate, useSearch} from '@tanstack/react-router';
import {useAuth} from '@workos-inc/authkit-react';
import * as React from 'react';
import {authLogger} from '@/features/auth/services/logger';

function AuthLoginView() {
  const {signIn, isLoading, user} = useAuth();
  const {returnTo} = useSearch({from: '/_public/auth/login'});
  const navigate = useNavigate({from: '/auth/login'});

  React.useEffect(() => {
    // Do nothing until we've checked the auth state
    if (isLoading) return;

    if (user) {
      // If we're already authenticated, redirect to the returnTo path
      authLogger.log('Already authenticated, redirecting to:', returnTo);
      navigate({to: returnTo});
      return;
    }

    // Only call signIn if we're not already authenticated
    authLogger.log('Starting authentication flow', {returnTo});
    signIn({
      state: {
        returnTo,
      },
    });
  }, [isLoading, user]);

  return <Loader />;
}

export {AuthLoginView};
